import { FC } from 'react';

/**
 * Pure positional marker — never actually mounted. Place it among an Info type's other children
 * (e.g. `ItemInfo.Status`, `.Flag`, `.Location`, `.PartOfKit`) to control where the
 * `fieldDefs`-driven auto-rendered list appears relative to them. With no children at all, the
 * list auto-renders regardless — this marker only matters once you're composing children yourself.
 */
export const Fields: FC = () => null;
